const _ = {
  PROFILE_IMAGES: "profile_images",
  PROGRESSIVE_PROFILE_STEPPER: "progressive_profile_stepper",
  REGISTRATION_TERMS_CONDITIONS: "sign_up_terms_and_condition",
  ACCOUNT_TYPE_DETAILS: "account_type_info",
  ACCOUNT_LIFE_CYCLE: "renewal_terms_and_conditions",
  CART_TERMS_CONDITIONS: "cart"
};
export {
  _
};
//# sourceMappingURL=cmsConstants-95f19583.mjs.map
